import { render, staticRenderFns } from "./blk3.vue?vue&type=template&id=065885ba"
import script from "./blk3.vue?vue&type=script&lang=js"
export * from "./blk3.vue?vue&type=script&lang=js"
import style0 from "./blk3.vue?vue&type=style&index=0&id=065885ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports